import * as React from 'react';
import { CopyableText } from '../copyable-text/copyable-text';

interface Props {
    phoneNumber?: string | null;
    className?: string;
    empty?: React.ReactNode;
}

// نمایش شماره موبایل همراه با دکمه کپی
export const CopyablePhone: React.FC<Props> = ({ phoneNumber, className, empty }) => (
    <CopyableText value={phoneNumber} label="شماره" className={className} empty={empty} />
);
